module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_7.4f24ba84.png";